import { IComponentOptions } from "angular";
import { DepreciationDetailsViewController } from "./controller";

export const vsName = "machineDetailDepreciationComponent";

export const machineDetailDepreciationComponentOptions: IComponentOptions = {
  controller: DepreciationDetailsViewController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
    depreciation: "<",
  },
};
